import { TectonBasicTable } from '@shared';
import { Title } from '@tecton';
import React from 'react';
import { WorkspaceStoreDetailsPanelData } from './detailsPanelQueryTypes';
import { DataFlowSidePanel, DescriptionSection } from './StyledPanelComponents';
import DetailsPanelAccordionSection from './DetailsPanelAccordionSection';

const OnlineStoreContextPanel = ({
  id,
  data,
  detailsPanelClearAll,
  zoomToNode,
}: {
  id: string;
  data?: WorkspaceStoreDetailsPanelData;
  detailsPanelClearAll: () => void;
  zoomToNode?: () => void;
}) => {
  return (
    <DataFlowSidePanel
      name={'Online Store'}
      prehead={`Store`}
      nodeId={id}
      detailsPanelClearAll={detailsPanelClearAll}
      zoomToNode={zoomToNode}
    >
      <DescriptionSection
        description={
          'An online store in Tecton is used to serve features in real time to your models and applications.'
        }
      />

      {data && (
        <>
          <DetailsPanelAccordionSection
            id="materializating-to-online-store"
            title={
              <Title size="xxs">
                <h4>Feature Views Materializing to the Online Store</h4>
              </Title>
            }
            initialIsOpen
          >
            {data.featureViews.length > 0 ? (
              <TectonBasicTable
                items={data.featureViews.filter((fv) => {
                  return fv.isOnlineMaterializationEnabled === true;
                })}
                columns={[
                  {
                    field: 'name',
                    name: 'Name',
                  },
                ]}
                pageIndex={0}
                pageSize={0}
                totalItemCount={0}
              />
            ) : (
              <p>No Feature Views materializing data to the online store.</p>
            )}
          </DetailsPanelAccordionSection>
        </>
      )}
    </DataFlowSidePanel>
  );
};

export default OnlineStoreContextPanel;
